import { createSlice } from "@reduxjs/toolkit";

const initialSection = {
  name: "",
  capacity: 1
};

const initialSectionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  section: initialSection
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const sectionSlice = createSlice({
  name: "sections",
  initialState: initialSectionsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getSection
    sectionFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.section = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanSectionsState
    sectionsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.section = initialSection;
    }
  }
});